import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';
import { CommandResult } from '../../../common/helpers/CommandResult';

export const sendPropertyInformationEnrichmentRequest = async (ssns: string[]): Promise<CommandResult> => {
    const result = await AxiosClientFactory
        .getInstance()
        .post(`/api/PropertyInformation/UpdateRequests`, ssns);

    return new CommandResult(result);
};